import * as z from 'zod';

/**
 * Метка «пришли из уведомления о сессии» в адресе заявки.
 *
 * Роутер разбирает `?sessionNotice=1` в ЧИСЛО 1, а схема ждала строку '1': страница с пушем и
 * письмом падала в «We couldn't load this page». Принимаем оба вида и отдаём всегда строку, а
 * любое другое значение молча отбрасываем: подсказка из уведомления не должна ронять страницу.
 */
export const sessionNoticeSearch = z
  .union([z.literal(1), z.literal('1')])
  .transform(() => '1' as const)
  .optional()
  .catch(undefined);
